if (!customElements.get('color-loader')) {
  class ColorLoader extends HTMLElement {
    constructor() {
      super();
    }

    getNextPageStyleTag(href) {
      const url = new URL(href);
      url.searchParams.set('view', 'color');

      fetch(url)
        .then((res) => res.text())
        .then((text) => {
          const html = new DOMParser().parseFromString(text, 'text/html');

          const style = html.querySelector('style');
          if (style) this.appendChild(style);

          const nextPage = html.querySelector('[js-next-page]');
          if (!nextPage) return;

          this.currentPage++;
          url.searchParams.set('page_ac0503ea', this.currentPage);
          this.getNextPageStyleTag(url);
        });
    }

    connectedCallback() {
      this.currentPage = 1;
      this.getNextPageStyleTag(window.location.origin);
    }
  }

  customElements.define('color-loader', ColorLoader);
}
